import React from "react";
import { Box } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";

import DashboardHeader from "../dashlibs/DashboardHeader";
import SummaryCard from "../dashlibs/SummaryCard";
import SectionCard from "../dashlibs/SectionCard";
import StatusBadge from "../dashlibs/StatusBadge";
import AlertList from "../dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../dashlibs/MockChart";

export default function Dashboard() {
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader />

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(5, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Budget total"
          value="69,94 Md FCFA"
          subtitle="Budget révisé sélectionné"
          delta="+25,72%"
          tone="info"
          icon={<AccountBalanceWalletOutlinedIcon />}
        />
        <SummaryCard
          title="Taux d’exécution"
          value="44,1%"
          subtitle="Au 30/06/2025"
          delta="+3,2 pts"
          tone="success"
          icon={<EqualizerOutlinedIcon />}
        />
        <SummaryCard
          title="Performance KPI"
          value="71%"
          subtitle="Score consolidé"
          delta="Stable"
          tone="default"
          icon={<TrackChangesOutlinedIcon />}
        />
        <SummaryCard
          title="Variance critique"
          value="5"
          subtitle="Postes sous tension"
          delta="2 urgents"
          tone="warning"
          icon={<InsightsOutlinedIcon />}
        />
        <SummaryCard
          title="Alertes"
          value="3"
          subtitle="À traiter aujourd’hui"
          delta="Priorité haute"
          tone="danger"
          icon={<WarningAmberOutlinedIcon />}
        />
      </Box>

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", lg: "1.35fr 1fr" },
        }}
      >
        <SectionCard
          title="Budget vs Réalisations"
          subtitle="Comparaison synthétique des principaux postes sur la période sélectionnée."
          action={<StatusBadge label="Révisé 2025" tone="info" />}
        >
          <MockTrendChart points={[42, 56, 61, 48, 70, 82, 74]} />
        </SectionCard>

        <SectionCard
          title="Centres de coûts"
          subtitle="Niveau d’exécution des principaux centres."
        >
          <MockBarChart
            data={[
              { label: "Direction Générale", value: 52, color: "#163A5F" },
              { label: "Opérations", value: 67, color: "#116B43" },
              { label: "DSI", value: 38, color: "#D68910" },
              { label: "Bingo", value: 59, color: "#2471A3" },
            ]}
          />
        </SectionCard>
      </Box>

      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", lg: "repeat(3, 1fr)" },
        }}
      >
        <SectionCard
          title="KPI par axe"
          subtitle="Progression des axes stratégiques sur la période."
        >
          <MockBarChart
            data={[
              { label: "Axe 1", value: 74, color: "#116B43" },
              { label: "Axe 2", value: 61, color: "#163A5F" },
              { label: "Axe 3", value: 54, color: "#D68910" },
              { label: "Axe 4", value: 68, color: "#2471A3" },
            ]}
          />
        </SectionCard>

        <SectionCard
          title="Activités critiques"
          subtitle="Activités nécessitant un suivi renforcé."
        >
          <AlertList
            items={[
              {
                title: "Infrastructure de réplication",
                description: "Dépassement potentiel sur l’enveloppe S1 et retard de mise en service.",
                tone: "warning",
              },
              {
                title: "Pointage des astreignants",
                description: "Avancement insuffisant par rapport à l’échéance de juin.",
                tone: "danger",
              },
              {
                title: "Interfaces JDE / LAS",
                description: "Exécution conforme, surveillance maintenue.",
                tone: "success",
              },
            ]}
          />
        </SectionCard>

        <SectionCard
          title="Produits / Dépôts"
          subtitle="Vue simplifiée par produit et localisation."
        >
          <MockBarChart
            data={[
              { label: "Super · Bingo", value: 49, color: "#116B43" },
              { label: "Gasoil · Bobo", value: 46, color: "#163A5F" },
              { label: "Gaz · Bingo", value: 58, color: "#2471A3" },
              { label: "Jet A1 · Bobo", value: 33, color: "#D68910" },
            ]}
          />
        </SectionCard>
      </Box>
    </Box>
  );
}
